import script from "./notification-popups-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./notification-popups-list.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__